export default {
  name: 'employeeDrugConsent',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(`/employee/${data.employeeid}/forms/drugalcoholconsent`, 'PUT', data);
  },
  restoreSave: (ctx) => {
  }
}
